import React from 'react';
import FormControl from '../Form/FormControl';
import { yupResolver } from '@hookform/resolvers/yup';
import TextField from '../Base/TextField/TextField';
import SubmitButton from '../Button/SubmitButton';
import apiClient from '../../Services/ApiClient';
import * as yup from 'yup';
import { CaseEntry } from './CaseChatEntry';
import ECardFolderSelectField from '../../Modules/Base/Components/Fields/ECardFolder/ECardFolderSelectField';
import CheckboxField from '../Form/components/CheckboxField';
import FormCondition from '../Form/FormCondition';
import usePatientConsent from '../PatientProfile/Hooks/usePatientConsent';
import PatientNoConsentProvided from '../../Modules/Patient/Components/PatientNoConsentProvided/PatientNoConsentProvided';
import useTranslation from '../../Hooks/useTranslation';
import FormWrapper from '../Form/FormWrapper';
import { useForm } from 'react-hook-form';

interface CaseChatEntryFileToDocumentationProps {
	entry: CaseEntry;
	onSuccess?: () => void;
	patientId: string;
	originalId: string;
}

export default function CaseChatEntryFileToDocumentation(
	props: CaseChatEntryFileToDocumentationProps,
) {
	const { entry, onSuccess, patientId, originalId } = props;
	const { t } = useTranslation();
	const { isConsentProvided } = usePatientConsent(patientId);

	// @ts-ignore
	const handleSave = async values => {
		const folderId = values.category.value;

		const url =
			'/cases/' +
			entry.caseId +
			'/move-to-documents/' +
			entry.id +
			'/' +
			folderId;
		await apiClient.put(url, {
			name: values.name,
			eCardFolderId: values?.eCardCategory?.value ?? undefined,
		});

		onSuccess && onSuccess();
	};

	const validationSchema = yup.object({
		name: yup.string().required(t('base.shared.filename')),
		category: yup.object().shape({
			value: yup.string().uuid().required(t('base.shared.category')),
		}),
		uploadToPatientECard: yup.boolean(),
		eCardCategory: yup.object().when('uploadToPatientECard', {
			is: true,
			then: yup.object().shape({
				value: yup
					.string()
					.uuid()
					.required(t('component.eCard.pickPatientECardCategory')),
			}),
		}),
	});

	const formMethods = useForm({
		resolver: yupResolver(validationSchema),
	});

	return (
		<FormWrapper formMethods={formMethods}>
			<FormControl label={'base.shared.filename'} name='name' isRequired>
				<TextField />
			</FormControl>
			<ECardFolderSelectField
				patientId={patientId}
				name='category'
				isRequired
				label='base.shared.category'
			/>
			{isConsentProvided ? (
				<>
					<CheckboxField
						name='uploadToPatientECard'
						tx='component.eCard.addToPatientsECard'
						className='mb-3 mt-3'
					/>
					<FormCondition controlName='uploadToPatientECard' equal={true}>
						<ECardFolderSelectField
							patientId={originalId}
							name='eCardCategory'
							label='component.eCard.pickPatientECardCategory'
							className='mb-2'
							isRequired
						/>
					</FormCondition>
				</>
			) : (
				<PatientNoConsentProvided patientId={patientId} />
			)}
			<div className={'mt-4'}>
				<SubmitButton title={'base.shared.save'} onSubmit={handleSave} />
			</div>
		</FormWrapper>
	);
}
